import { MdSettings } from 'react-icons/md';
import { MessageGroupController } from './messageGroupInterface';
import { MessageGroupViewProps } from './messageGroupProps';
import { MessageGroupAggregate } from './messageGroupModel';

export function createMessageGroupController(): MessageGroupController {
    function formatTime(value: Date) {
        return value.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    function getAuthorProps(
        item: MessageGroupAggregate
    ): MessageGroupViewProps['author'] {
        const name = item.definition.display_name || 'Agent';
        const isOwn = item.role === 'user';

        if (item.role === 'user') {
            return {
                role: item.role,
                label: 'Me',
                avatar: {
                    kind: 'avatar',
                    text: 'Me',
                },
                isOwn,
            };
        }
        if (item.role === 'system') {
            return {
                role: item.role,
                label: 'System',
                avatar: {
                    kind: 'icon',
                    Icon: MdSettings,
                },
                isOwn,
            };
        }
        return {
            role: item.role,
            label: name,
            avatar: {
                kind: 'avatar',
                text: name,
            },
            isOwn,
        };
    }
    return {
        useProps(context, item, props) {
            const [first] = item.messages;
            return {
                id: item.id,
                author: getAuthorProps(item),
                messages: item.messages.map((message) => ({
                    item: message,
                })),
                timestamp: {
                    label: formatTime(first.message.createdAt),
                },
            };
        },
    };
}
